import { render, staticRenderFns } from "./ClientRegisterFormPage.vue?vue&type=template&id=26c95eec&scoped=true"
import script from "./ClientRegisterFormPage.vue?vue&type=script&lang=js"
export * from "./ClientRegisterFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c95eec",
  null
  
)

export default component.exports